import { render, staticRenderFns } from "./HouseDetailDialog.vue?vue&type=template&id=60c12d2d&scoped=true"
import script from "./HouseDetailDialog.vue?vue&type=script&lang=js"
export * from "./HouseDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./HouseDetailDialog.vue?vue&type=style&index=0&id=60c12d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c12d2d",
  null
  
)

export default component.exports